import CuratorPlanningReviews from './review-plan-page'

export default CuratorPlanningReviews
